import React from "react";

function ConfirmedIcon({ stroke = "#039855", w = "30", h = "30" }) {
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.1667 13.6143V14.841C28.165 17.7162 27.234 20.5139 25.5124 22.8167C23.7909 25.1196 21.371 26.8043 18.6138 27.6195C15.8566 28.4347 12.9097 28.3368 10.2126 27.3404C7.51557 26.344 5.21287 24.5024 3.64795 22.0904C2.08302 19.6783 1.33972 16.8251 1.5289 13.9561C1.71808 11.0871 2.82961 8.35607 4.69771 6.1704C6.5658 3.98472 9.09038 2.46147 11.8949 1.82783C14.6995 1.19418 17.6337 1.48408 20.26 2.6543M28.1667 4.1743L14.8333 17.521L10.8333 13.521"
        stroke={stroke}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ConfirmedIcon;
